import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../services/axiosInstance';

const CategorySelector = () => {
  const [categories, setCategories] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // Récupération initiale des catégories
    axiosInstance.get('/categories_easy_drinks/categories')
      .then(response => {
        setCategories(response.data);
        return response.data;
      })
      .then(fetchedCategories => {
        // Récupération de la disposition actuelle des catégories
        axiosInstance.get('/drinks/category-disposition')
          .then(response => {
            console.log(response)
            const order = response.data.order.map(Number);
            const validIds = order.filter(id => fetchedCategories.some(cat => cat.id === id || (cat.subCategories && cat.subCategories.some(subCat => subCat.id === id))));
            setSelectedIds(validIds);
            setLoading(false);
          })
          .catch(error => {
            console.error('Erreur lors de la récupération de la disposition des catégories', error);
            setLoading(false);
          });
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des catégories', error);
        setLoading(false);
      });
  }, []);

  const handleSelectCategory = (id) => {
    setSelectedIds(prevIds => {
      if (prevIds.includes(id)) {
        return prevIds.filter(prevId => prevId !== id);
      } else {
        return [...prevIds, id];
      }
    });
  };

  const getSelectedCategoryNames = () => {
    let selectedNames = selectedIds.map(id => {
      let name = '';
      const findName = (categories) => {
        for (let category of categories) {
          if (category.id === id) {
            name = category.name;
            return;
          }
          if (category.subCategories && category.subCategories.length > 0) {
            findName(category.subCategories);
          }
        }
      };
      findName(categories);
      return name;
    });
    return selectedNames.join(', ');
  };

  const renderCategory = (category, isSubCategory = false) => (
    <div 
      key={category.id} 
      className={`category-item ${isSubCategory ? 'sub-category' : 'main-category'} ${selectedIds.includes(category.id) ? 'selected' : ''}`}
    >
      <label className="category-label">
        <input
          type="checkbox"
          className="category-checkbox"
          checked={selectedIds.includes(category.id)}
          onChange={() => handleSelectCategory(category.id)}
        />
        <span className="checkbox-custom"></span>
        <span className="category-name">{category.name}</span>
        {selectedIds.includes(category.id) && (
          <span className="selected-badge">
            #{selectedIds.indexOf(category.id) + 1}
          </span>
        )}
      </label>
      {category.subCategories && category.subCategories.length > 0 && (
        <div className="subcategories-container">
          {category.subCategories.map(subCategory => renderCategory(subCategory, true))}
        </div>
      )}
    </div>
  );

  const handleSubmit = () => {
    setSaving(true);
    axiosInstance.post('/drinks/save-category-disposition', { categories: selectedIds })
      .then(response => {
        console.log('Disposition enregistrée avec succès');
        setSaving(false);
      })
      .catch(error => {
        console.error('Erreur lors de l\'enregistrement de la disposition', error);
        setSaving(false);
      });
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Chargement des catégories...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <style jsx>{`
        .container {
          max-width: 800px;
          margin: 0 auto;
          padding: 30px;
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          margin-bottom: 100px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
        }

        .header {
          text-align: center;
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 2px solid #f0f2f5;
        }

        .header h1 {
          color: #1a202c;
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 10px 0;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .header p {
          color: #718096;
          font-size: 16px;
          margin: 0;
        }

        .selected-summary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 20px;
          border-radius: 12px;
          margin-bottom: 30px;
          box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
        }

        .selected-summary h3 {
          margin: 0 0 10px 0;
          font-size: 18px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .selected-count {
          background: rgba(255, 255, 255, 0.2);
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 600;
        }

        .selected-text {
          font-size: 14px;
          line-height: 1.6;
          opacity: 0.95;
          word-break: break-word;
        }

        .categories-grid {
          display: grid;
          gap: 16px;
          margin-bottom: 30px;
        }

        .category-item {
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          background: #ffffff;
          transition: all 0.3s ease;
          overflow: hidden;
        }

        .category-item:hover {
          border-color: #cbd5e0;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }

        .category-item.selected {
          border-color: #667eea;
          background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
          box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
        }

        .main-category {
          border-width: 2px;
        }

        .sub-category {
          margin-left: 30px;
          border-width: 1px;
          border-style: dashed;
          background: #f8fafc;
        }

        .sub-category.selected {
          background: linear-gradient(135deg, #f0fff4 0%, #f7fafc 100%);
          border-color: #48bb78;
        }

        .category-label {
          display: flex;
          align-items: center;
          padding: 16px 20px;
          cursor: pointer;
          position: relative;
          gap: 15px;
        }

        .category-checkbox {
          opacity: 0;
          position: absolute;
          width: 0;
          height: 0;
        }

        .checkbox-custom {
          width: 20px;
          height: 20px;
          border: 2px solid #cbd5e0;
          border-radius: 6px;
          position: relative;
          transition: all 0.3s ease;
          flex-shrink: 0;
        }

        .category-checkbox:checked + .checkbox-custom {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-color: #667eea;
        }

        .category-checkbox:checked + .checkbox-custom::after {
          content: '✓';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 12px;
          font-weight: bold;
        }

        .category-name {
          font-size: 16px;
          font-weight: 600;
          color: #2d3748;
          flex: 1;
        }

        .sub-category .category-name {
          font-size: 14px;
          font-weight: 500;
          color: #4a5568;
        }

        .selected-badge {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          margin-left: auto;
        }

        .subcategories-container {
          border-top: 1px solid #e2e8f0;
          background: #fafafa;
        }

        .submit-button {
          width: 100%;
          padding: 16px 32px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .submit-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 30px rgba(102, 126, 234, 0.4);
        }

        .submit-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .loading-spinner {
          text-align: center;
          padding: 60px 20px;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #e2e8f0;
          border-top: 4px solid #667eea;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .empty-state {
          text-align: center;
          padding: 40px 20px;
          color: #718096;
        }

        .empty-state svg {
          width: 64px;
          height: 64px;
          margin-bottom: 16px;
          opacity: 0.5;
        }

        @media (max-width: 768px) {
          .container {
            margin: 20px;
            padding: 20px;
          }

          .header h1 {
            font-size: 24px;
          }

          .sub-category {
            margin-left: 15px;
          }

          .category-label {
            padding: 12px 16px;
          }
        }
      `}</style>

      <div className="header">
        <h1>Gestion des Catégories</h1>
        <p>Sélectionnez et organisez vos catégories de boissons</p>
      </div>

      <div className="selected-summary">
        <h3>
          Catégories sélectionnées 
          <span className="selected-count">{selectedIds.length}</span>
        </h3>
        <div className="selected-text">
          {selectedIds.length === 0 ? 
            "Aucune catégorie sélectionnée" : 
            getSelectedCategoryNames()
          }
        </div>
      </div>

      <div className="categories-grid">
        {categories.length === 0 ? (
          <div className="empty-state">
            <svg fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
            <h3>Aucune catégorie disponible</h3>
            <p>Les catégories seront affichées ici une fois chargées</p>
          </div>
        ) : (
          categories.map(category => renderCategory(category))
        )}
      </div>

      <button 
        className="submit-button" 
        onClick={handleSubmit}
        disabled={saving || selectedIds.length === 0}
      >
        {saving ? (
          <>
            <div className="spinner" style={{width: '16px', height: '16px', borderWidth: '2px'}}></div>
            Enregistrement en cours...
          </>
        ) : (
          <>
            💾 Enregistrer la disposition ({selectedIds.length} catégories)
          </>
        )}
      </button>
    </div>
  );
};

export default CategorySelector;